// Spanish translation

const es = {
  "crm.title_main":
    "Centraliza estrategias, procesos y software para gestionar interacciones que te llevará a mejores relaciones con tu cliente, un equipo más productivo y potenciar tus ventas.",
  "party.party.commercial_name": "Nombre Comercial",
  "crm.opportunity.commercial_name": "Nombre Comercial",
  "crm.activity.planned_date.filter": "Fecha Planeada",
  "crm.activity.type_.filter": "Tipo",
  "crm.prospect.lead_origin": "Origen",
  "crm.prospect.party_category": "Categoria",
  "crm.prospect.party_category.filter": "Categoria",
  "crm.prospect.lead_origin.filter": "Origen",
  "crm.prospect.comment": "Comentario",
  "crm.activity.opportunity.filter": "Oportunidad",
  "crm.opportunity.start_date_from.filter": "Fecha inicio desde",
  "crm.opportunity.start_date_to.filter": "Fecha inicio hasta",
  "crm.opportunity.end_date.filter": "Fecha final",
  "crm.activity.opportunity": "Oportunidad",
  "crm.activity.planned": "Planeado",
  "crm.activity.rescheduled": "Reprogramado",
  "crm.activity.done": "Terminado",
  "crm.activity.today": "Para Hoy",
  "crm.activity.tomorrow": "Para Mañana",
  "crm.activity.thisWeek": "Esta Semana",
  "crm.activity.nextWeek": "Próxima Semana",
  "crm.activity.overdue": "Vencidas",
  "crm_opportunities_title": "Oportunidad",
  "crm_prospects_title": "Prospectos",
  "crm_activities_title": "Actividad",
  "crm.opportunity.new_oportunities_title": "Oportunidades Nuevas",
  "crm.opportunity.won_month_title": "Ganadas Mes",
  "party.party.fiscal_regimen": "Regimen Fiscal",
  "party.party.type_person": "Tipo de Persona",
  "crm.opportunity.company_name": "Empresa",
  "crm.activity.number": "Actividad",
  "crm.opportunity.report": "Cotización",
  "crm.opportunity.contact_company": "Empresa"
};

export default es;
